<template>
  <div>
    <div class="d-flex justify-space-between align-center mt-2">
      <div class="text-subtitle-2">{{ $tc('result', 2) }}</div>
      <table-pagination-controls
        :total-rows="remoteData.totalRows"
        :current-page.sync="remoteData.currentPage"
        :rows-per-page.sync="remoteData.rowsPerPage"
        @update:currentPage="refreshResults"
        @update:rowsPerPage="initiateSearch"
        :per-page-options="remoteData.pageOptions"/>
      <div></div>
    </div>
    <v-data-table
      hide-default-footer
      class="vf-table mt-2"
      :headers="tableFields"
      :items="remoteData.items"
      :server-items-length="remoteData.totalRows"
      :sort-by.sync="remoteData.sortBy"
      :sort-desc.sync="remoteData.sortDesc"
      :loading="remoteData.isBusy"
      :loading-text="$t('loading')"
      @update:sort-by="initiateSearch()"
      @update:sort-desc="initiateSearch()">
      <template #item.sent="row">
        <multi-time-display :time="row.value"/>
      </template>
      <template #item.recipient="row">
        <router-link :to="`/user/${row.item.user_id}`">
          {{ row.value }}
        </router-link>
      </template>
      <template #item.subject="row">
        {{ row.value }}
      </template>
    </v-data-table>
  </div>
</template>

<script>
import MultiTimeDisplay from '@/components/shared/MultiTimeDisplay'
import RemoteDataTableMixin from '@/components/mixins/RemoteDataTableMixin'
import TablePaginationControls from '@/components/shared/TablePaginationControls'

import dateFormat from 'dateformat'
import { defaults } from 'lodash'

export default {
  name: 'NotificationHistory',
  components: {
    MultiTimeDisplay,
    TablePaginationControls
  },
  mixins: [
    RemoteDataTableMixin
  ],
  props: {
    autoload: {
      type: Boolean,
      default: true
    },
    initSearchCriteria: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      model: 'Notification',
      searchCriteria: this.getDefaultSearchCriteria(),
      remoteDataTableAutoLoad: false,
      tableFields: [
        {
          value: 'sent',
          text: this.$t('sent')
        },
        {
          value: 'recipient',
          text: this.$t('recipient')
        },
        {
          value: 'subject',
          text: this.$t('subject'),
          sortable: false
        }
      ]
    }
  },
  methods: {
    /**
     * Returns the default search criteria for this data table (DRY)
     *
     * @return Object
     */
    getDefaultSearchCriteria () {
      const defaultSearchCriteria = {
        resourceType: null,
        primaryKey: null,
        createdAfter: dateFormat(new Date(), 'm/d/yyyy')
      }
      return defaults({}, this.initSearchCriteria, defaultSearchCriteria)
    },

    /**
     * Constructs an object of key value pairs that represent the current search criteria.
     * @return object
     */
    buildSearchCriteria () {
      const fields = [
        'id',
        'user_id',
        'recipient',
        'subject',
        'sent',
        'created'
      ]
      const searchCriteria = {
        fields: fields.join(','),
        created_after: dateFormat(this.searchCriteria.createdAfter, 'isoDateTime'),
        page: this.remoteData.currentPage,
        'per-page': this.remoteData.rowsPerPage
      }
      if (this.searchCriteria.resourceType !== null) {
        searchCriteria.resource_type = this.searchCriteria.resourceType
      }
      if (this.searchCriteria.primaryKey) {
        searchCriteria.primary_key = this.searchCriteria.primaryKey
      }
      return searchCriteria
    }
  },
  mounted () {
    if (this.autoload) {
      this.initiateSearch()
    }
  }
}
</script>
